import React from "react";
import {message} from "antd";
import server from "../../../../server";
import PrimaryDetailView from "./primary-detail.view";
import {useBaseComponent} from "../../../../base/base-component";
import {IState, IPrimaryDetailProps, IPrimaryDetailFormModel, IData} from "./types/primary-detail.types";
import {
    fetchData,
    modelMapper,
    viewMapper
} from "./action/primary-detail-actions";
import DataLoading from "../../../../common/loading-data";

const PrimaryDetail = (props: IPrimaryDetailProps) => {
    const {
        goToNextTab,
        employeeId,
        updateEmployeeId,
        user
    } = props;

    const {state, updateState} = useBaseComponent<IPrimaryDetailProps, IState>(props, {
        initialState: () => ({
            internal: {
                loading: false,
            }
        }),
        onInit: () => onInit()
    });

    const onInit = async () => {
        if (employeeId) {
            let data: IData = await fetchData(employeeId);
            updateState('data', data);
        } else {
            if (user) {
                const data = {
                    primary: {
                        userId: user.id,
                        name: {
                            firstName: user.firstName,
                            middleName: user.middleName,
                            lastName: user.lastName,
                        },
                        officialEmailId: user.email,
                    },
                };
                updateState('data', data);
            } else {
                message.error("Initialization failed. Either employee id or user missing.")
            }
        }
    }

    async function onSubmit(formValues: IPrimaryDetailFormModel) {
        updateState('data.loading', true);
        try {
            let payload = modelMapper(formValues);
            if (employeeId) {
                await server.employee.primary.update(employeeId, payload);
                updateState('data.primary', payload);
                message.success("Primary details updated successfully!");
            } else {
                const location = await server.employee.primary.create(payload);
                const employeeId = location.split("/").pop();
                updateEmployeeId(employeeId);
                message.success("Primary details submitted successfully!");
            }
        } catch (error) {
            message.error("Please fill in all required fields.");
        } finally {
            updateState('data.loading', false);
        }
    }

    return (
        state.data === undefined ? <DataLoading title="Primary Details"/> :
            <PrimaryDetailView
                loading={state.internal.loading}
                viewModel={viewMapper(state.data)}
                onSubmit={onSubmit}
                goToNextTab={goToNextTab}
                employeeId={employeeId}
            />
    )
};

export default PrimaryDetail;